module.exports = __webpack_public_path__ + "static/media/1POLICY32.84138279.jpg";